<!-- <div class="mainPanel reportMainPanel clientMainPanel editTeamAttendanceTable">
    <div class="midPanel mobMidPanel">
        <div class="mobBackSec">
            <a (click)="navigateToTeamAttendnace();" href="#" class="bckArrow">
                <i class="material-icons">arrow_back</i>
                {{userInfo && userInfo.name ? userInfo.name : ''}}
            </a>                  
         </div>
        <div class="fullPanel">
            <div class="breadcrumbSec">
               
                <div class="breadcrumbText">
                    <p><a href="#">Home</a> / <a href="#">Attendance</a> / {{userInfo && userInfo.name ? userInfo.name : ''}} Attendance </p>
                </div>
            </div>
            <div class="topRightSec">

            </div>
        </div> -->
        <!-- <div class="mobtaskBtn dropup dropdown customDropdown">
            <a href="#" class="taskAddBtn dropdown-toggle" data-toggle="dropdown"><i class="material-icons">add</i></a>
            <div class="dropdown-menu dropdown-menu-right">
               <a class="dropdown-item" href="#">Create Schedule</a>
           
            </div>
         </div> -->
        <div class="fullContainer singleViewContainer">
            <div class="formContainer">
                <form action="#">
                    <div class="formScroll  mCustomScrollbar" data-mcs-theme="minimal-dark">
                        <div class="reportpanel">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="lastCheckHead"(click)="isAllCheck = !isAllCheck; checkAllClick();">
                                                <p>Check All</p>
                                            </th>
                                            <th scope="col">
                                                <p>Date</p>
                                            </th>
                                            <th scope="col">
                                                <p>Attendance</p>
                                            </th>
                                            <th scope="col">
                                                <p>Status</p>
                                            </th>
                                            <th scope="col">
                                                <p>Action</p>
                                            </th>
                                            <th scope="col">
                                                <p>Attendance Date & Time</p>
                                            </th>
                                            <!-- <th scope="col">
                                                <p>Note</p>
                                            </th> -->
                                            <th scope="col">
                                                <p>Note by employee</p>
                                            </th>
                                            <th scope="col">
                                                <p>Start and End Work Timing</p>
                                            </th>
                                            <th scope="col">
                                                <p>Total Hours</p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="personAttendnaceDetailsList.length==0 ">
                                        <tr>
                                            <div class="nodataDiv">
                                                <span class="nodataimg"><img src="assets/img/nodataImg.png" alt=""></span>
                                                <p>No Attendance Marked</p>
                                    
                                            </div>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngFor="let attendance of personAttendnaceDetailsList |orderBy: 'timeForSort': false; let i = index;">
                                            <td scope="col" class="columCenter">
                                                <p><label><input type="checkbox" name="checkbox{{i}}" [(ngModel)]="attendance.isChecked"></label></p>
                                            </td>
                                            <td>
                                                <p>{{attendance.dateStr}}</p>
                                            </td>
                                            <td>
                                                <p>{{attendance.attendanceStr}}</p>
                                              

                                            </td>
                                            <td>
                                                <p  [ngStyle]="{'color': attendance.statusClass}">{{attendance.statusStr ? attendance.statusStr : '-'}}</p>
                                            </td>

                                            <td>
                                                <div class="formSec">
                                                    <div class="selectboxSec">
                                                        <ng-select class="select form-control e1" 
                                                            [items]="statusList" 
                                                            bindLabel="text"
                                                            [virtualScroll]="true" 
                                                            [closeOnSelect]="true" 
                                                            [(ngModel)]="attendance.approveStatusObj" 
                                                            name="status{{i}}"
                                                            [clearable]="false"
                                                            placeholder="Select Action" 
                                                            [ngClass]="attendance.approveStatusObj ? 'selectfocus': ''">
                                                            <ng-template ng-label-tmp let-item="item">
                                                                <div [ngStyle]="{'color': item.colorClass}">{{item.text}}</div>
                                                            
                                                            </ng-template>
                                        
                                                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                                                <div [ngStyle]="{'color': item.colorClass}">{{item.text}}</div>
                                                            
                                                            </ng-template>
                                                        </ng-select>
                                                    </div>
                                                </div>

                                                        <!-- <p  class="{{attendance.statusClass}}">{{attendance.statusStr}}</p> -->
                                            </td>
                                            <td>
                                                <p>{{attendance.markAttendnaceDateStr}}</p>
                                            </td>
                                            <td>
                                                <p>{{attendance.remark}}</p>
                                            </td>
                                            <td>
                                                <p>{{attendance.startEndTimingStr}}</p>
                                            </td>
                                            <td>
                                                <p>{{attendance.totalHrsStr}}</p>
                                            </td>
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </form>
                <div class="filter-sec-foot clearfix">

                    <button type="button" class="btn btn-default ripple blueBtn" (click)="onApproveClick();">Submit</button>
                    <button type="button" class="btn btn-default ripple lineBlueBtn" (click)="navigateToTeamAttendnace();">Cancel</button>
                </div>
            </div>
        </div>
    <!-- </div>  -->